import { api } from './api';

export async function listIntakeJobs(includeReviewed = false) {
  const q = includeReviewed ? '?includeReviewed=1' : '';
  const res = await api.get(`/api/intake-jobs${q}`);
  return res.jobs || [];
}

export async function reviewIntakeJob(id, reviewed = true) {
  return await api.post(`/api/intake-jobs/${id}/review`, { reviewed });
}

// Elation user-facing chart URL (matches components/fax-filed-item.jsx).
export function elationChartUrl(patientId) {
  if (!patientId) return null;
  return `https://app.elationemr.com/patient/${encodeURIComponent(patientId)}/`;
}
